import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import DashboardNavbar from "../components/layouts/dashboardNav";
import DataTable from "../components/layouts/table";



function BookingRecord(){


    return(
        <>
        <DashboardNavbar/>
        <Box sx={{backgroundColor:"black"}}>
        <Typography variant="h4" sx={{color:"white"}}>Booking Information</Typography>
        <DataTable/>
        </Box>
        </>
    )



}



export default BookingRecord;